var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"market-filter-wrapper"},[_c('div',{staticClass:"market-filter"},[_vm._l((_vm.categories),function(category){return _c('div',{key:category,staticClass:"market-filter__item",class:{
                'market-filter__active': category === _vm.activeCategory,
            },on:{"click":function($event){return _vm.selectCategory(category)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(`jetton_filters.${category}`)))])])}),_vm._v(" "),_c('dyor-logo')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }